import React from 'react';
import { Loader } from '@keen.io/ui-core';
import { BodyText } from '@keen.io/typography';
import { colors } from '@keen.io/colors';
import { Container, Wrapper } from './TimezoneLoader.styles';

var TimezoneLoader = function TimezoneLoader(_ref) {
  var message = _ref.message;
  return React.createElement(Container, null, React.createElement(Loader, {
    width: 18,
    height: 18
  }), React.createElement(Wrapper, null, React.createElement(BodyText, {
    variant: "body2",
    color: colors.blue[500]
  }, message)));
};

export default TimezoneLoader;